import { IPlayer } from '@base/features/player/model/interfaces';
import PopoverPlayerAdditionalInfo from '@base/features/playerAdditionalInfo/popoverPlayerAdditionalInfo/popoverPlayerAdditionalInfo';
import { Avatar } from '@base/features/avatar/components/avatar';
import React from 'react';
import coin from '@base/assets/images/coin.png';
import styles from '../styles/invitesListItem.module.scss';

export const InvitesListItem = (props: { player: IPlayer }) => {
  const { player } = { ...props };

  return (
    <PopoverPlayerAdditionalInfo placement="left" key={player.pid} player={player}>
      <div className={styles.player} key={player.name}>
        <div className={styles.avatar}>
          <Avatar player={player} />
        </div>
        <div className={styles.player}>
          <div className={styles.username}>{player.name}</div>
          <div>
            {player.isTicketPlayer() ? (
              <img
                //TODO убрать классы из другого компонента
                className="messages__author-ticket"
                src={coin}
                alt="ticket"
              />
            ) : null}
          </div>
        </div>
      </div>
    </PopoverPlayerAdditionalInfo>
  );
};
